export type WelcomeLoginDialogStep = 'LOGIN' | 'EMIRATES_ID';

/**
 * In-memory handoff: Bloom Universal CTA → Welcome login dialog
 * when navigation does not include query params.
 */
let welcomeOpenLoginToken = 0;
let keepWelcomeLoginDialogOpen = false;
let welcomeLoginDialogStep: WelcomeLoginDialogStep = 'LOGIN';
/** Session-only: user closed dialog; reset on full page refresh. */
let welcomeLoginQueryDismissed = false;

export function markWelcomeOpenLogin(
  step: WelcomeLoginDialogStep = 'LOGIN',
): void {
  welcomeOpenLoginToken += 1;
  keepWelcomeLoginDialogOpen = true;
  welcomeLoginDialogStep = step;
}

export function setWelcomeLoginDialogStep(step: WelcomeLoginDialogStep): void {
  welcomeLoginDialogStep = step;
}

export function getWelcomeLoginDialogStep(): WelcomeLoginDialogStep {
  return welcomeLoginDialogStep;
}

export function getWelcomeOpenLoginToken(): number {
  return welcomeOpenLoginToken;
}

/** Keep dialog open across remount without bumping the CTA token. */
export function ensureWelcomeLoginDialogKeep(): void {
  keepWelcomeLoginDialogOpen = true;
}

export function shouldKeepWelcomeLoginDialogOpen(): boolean {
  return keepWelcomeLoginDialogOpen;
}

export function clearWelcomeLoginDialogKeep(): void {
  keepWelcomeLoginDialogOpen = false;
  welcomeLoginDialogStep = 'LOGIN';
  welcomeOpenLoginToken = 0;
}

/** User closed the dialog; blocks reopen until the next explicit open action. */
export function markWelcomeLoginQueryDismissed(): void {
  welcomeLoginQueryDismissed = true;
}

export function clearWelcomeLoginQueryDismissed(): void {
  welcomeLoginQueryDismissed = false;
}

export function isWelcomeLoginQueryDismissed(): boolean {
  return welcomeLoginQueryDismissed;
}
